import React, { useState } from 'react';
import { FaWhatsapp, FaSpotify, FaMusic } from 'react-icons/fa';
import { FiX, FiChevronUp } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingElements = () => {
  const [showMusic, setShowMusic] = useState(true);
  const waNumber = "529841771113";

  return (
    <>
      {/* Floating WhatsApp Button */}
      <a 
        href={`https://wa.me/${waNumber}?text=Hola! I want to book an appointment / Quiero agendar una cita.`}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 z-[9990] bg-[#25D366] text-white p-4 rounded-full shadow-[0_0_20px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform duration-300 flex items-center justify-center group"
      >
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-30"></div>
        <FaWhatsapp className="text-3xl relative z-10" />
        <span className="absolute right-full mr-4 bg-white text-black px-3 py-1 rounded-lg text-xs font-bold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
          Chat with Us
        </span>
      </a>

      {/* Floating Spotify Player */}
      <div className="fixed bottom-24 right-6 z-[9980] flex flex-col items-end">
        <AnimatePresence>
          {showMusic && (
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              className="mb-4 w-[300px] bg-black/90 rounded-xl overflow-hidden shadow-2xl border border-mx-green/50"
            >
              <div className="flex justify-between items-center p-2 bg-gradient-to-r from-mx-green to-mx-red">
                <span className="text-[10px] uppercase font-bold text-white tracking-widest flex items-center gap-2">
                  <FaSpotify /> Relax & Lash Playlist
                </span>
                <button onClick={() => setShowMusic(false)} className="text-white hover:text-black">
                  <FiX />
                </button>
              </div>
              <iframe 
                data-testid="embed-iframe" 
                style={{ borderRadius: '0 0 12px 12px' }} 
                src="https://open.spotify.com/embed/playlist/37i9dQZF1DXeanowPcWEJB?utm_source=generator" 
                width="100%" 
                height="80" 
                frameBorder="0" 
                allowFullScreen="" 
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                loading="lazy"
              ></iframe>
            </motion.div>
          )}
        </AnimatePresence>
        
        {!showMusic && (
          <button 
            onClick={() => setShowMusic(true)}
            className="bg-black text-mx-green p-3 rounded-full border border-mx-green shadow-xl hover:bg-mx-green hover:text-white transition-colors"
          >
            <FaMusic />
          </button>
        )}
      </div>
    </>
  );
};

export default FloatingElements;